import React from 'react';

function AccountInfo(props) {
    const { data, names } = props;
    const { name, deposit, account } = data;
    return (
        <div>
            <div style={{ margin: '10px 0', padding: '0 10px', width: '60%', lineHeight: '32px', background: '#f1f1f1' }}>
                {names.accountInfo}
            </div>
            <table className="quotation_table" style={{width: '60%'}}>
                <tbody>
                    <tr>
                        <td className="quotation_td_left bg">{names.accountName}</td>
                        <td className="quotation_td_right">
                            { name }
                        </td>
                    </tr>
                    <tr>
                        <td className="quotation_td_left bg">{names.bankOfDeposit}</td>
                        <td className="quotation_td_right">
                            { deposit }
                        </td>
                    </tr>
                    <tr>
                        <td className="quotation_td_left bg">{names.bankAccount}</td>
                        <td className="quotation_td_right">
                            { account ? String(account).replace(/\d{4}/g, '$& ') : ''}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default AccountInfo;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Payment/Table/AccountInfo.js